import React from 'react'
import TextBlock from '../TextBlock/TextBlock'
import './StackCard.css'

const StatCard = props => {
  let stat = props.stat
  return (
    <div
      className="wow slideInLeft fmbm-stat-card"
      style={{ backgroundColor: stat.backgroundColor }}
    >
      <div className="fmbm-stat-card__img">
        <img src={stat.img} alt={stat.header + stat.body + stat.footer} />
      </div>
      <div>
        <p className="fmbm-stat-card__header" style={{ color: stat.textColor }}>
          {stat.header}
        </p>
        <p className="fmbm-stat-card__body">{stat.body}</p>
        <div
          className="fmbm-stat-card__footer"
          style={{ color: stat.textColor }}
        >
          {typeof stat.footer === 'function' ? stat.footer() : stat.footer}
        </div>
      </div>
    </div>
  )
}

const StackCard = props => {
  let stats = [
    {
      img: require('./images/rocket.png'),
      backgroundColor: '#19d0cf',
      textColor: '#9ffdfd',
      header: "We've worked with over ",
      body: '1000+',
      footer: 'Startups & websites',
    },
    {
      img: require('./images/people.png'),
      backgroundColor: '#17c6fa',
      textColor: '#a8ebff',
      header: 'Our products are used by ',
      body: '600M+',
      footer: 'Annual consumers',
    },
    {
      img: require('./images/laptop.png'),
      backgroundColor: '#7e3fdb',
      textColor: '#c6a8f3',
      header: 'Our team knows over ',
      body: '5 & 15',
      footer: () => (
        <div>
          Frameworks <span style={{ float: 'right' }}>Languages</span>
        </div>
      ),
    },
  ]
  return (
    <div className="fmbm-stack-card">
      <div className="fmbm-stack-card__card-list">
        {stats.map((el, index) => <StatCard key={index} stat={el} />)}
      </div>
      <div className="fmbm-stack-card__card-desc">
        <TextBlock
          headerText={'Our work is proven'}
          bodyText={`We've created software that's been used on over a thousand startups & websites worlwide, by roughly 600 million annual consumers. What's more? We're not tied to a single piece of software or language. Typically, in the development cycle, a startup founder tends to have to dream within the constraints of what their developers know. With our team, there are truly no limits.`}
          button={{
            text: 'Work with us',
            href: '#',
            color: '#113a9c',
          }}
        />
      </div>
    </div>
  )
}

export default StackCard



// WEBPACK FOOTER //
// ./src/Components/StackCard/StackCard.js